




























































































































































































































import Vue from "vue";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import { RootState } from "@/store";

import DateMomentTooltip from "@/components/DateMomentTooltip.vue";

import { formatSeconds } from "@/utility/Formatter";
import { AgentInfo } from "@/model/data/AgentInfo";

import { AgentTunnelSession } from "@/model/data/remoteLink/AgentTunnelSession";
import { StartAgentTunnelSessionResData } from "@/model/communication/remoteLink/StartAgentTunnelSessionResData";
import { StartAgentTunnelSessionCommand } from "@/model/communication/remoteLink/StartAgentTunnelSessionCommand";
import { StopAgentTunnelSessionCommand } from "@/model/communication/remoteLink/StopAgentTunnelSessionCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { TunnelProtocolEnum, TunnelProtocolEnumToString, TunnelProtocolToPort, TunnelProtocolEnumToProtocolName } from "@/model/data/enums/TunnelProtocolEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { GetAgentTunnelServiceConnectedTimeCommand } from "@/model/communication/remoteLink/GetAgentTunnelServiceConnectedTimeCommand";
import { GetAgentTunnelServiceConnectedTimeResData } from "@/model/communication/remoteLink/GetAgentTunnelServiceConnectedTimeResData";
import { OsTypeEnum } from "@/model/data/enums/OsTypeEnum";

export default Vue.extend({
    components: { DateMomentTooltip },
    props: {
        session: AgentTunnelSession,
        installationName: String,
        protocol: Number as () => TunnelProtocolEnum,
        loading: Boolean,
        agentInfo: Object as () => AgentInfo,
        osType: Number as () => OsTypeEnum,
    },
    data() {
        return {
            moment,
            copyLabel: "Copy",
            hostAlpha: "0.87",
            portAlpha: "0.87",
            canCopy: window.isSecureContext,
            showUrl: false,
            startSessionLoading: false,
            stopSessionLoading: false,
            localSession: this.session,
            secureConnection: false,
            TunnelProtocolEnum,
            localProtocol: this.protocol,
            alertType: "",
            errorMessage: "",
            showAlert: false,
            loadingChart: false,
            loadingNetworkChart: false,
            dateListString: [],
            seriesConnectedTime: [],
            notLaunchableProtocol: [TunnelProtocolEnum.CService, TunnelProtocolEnum.UltraVNC],
            copyIcon: "copy",
            cursorIcon: "i-cursor",
            circleIcon: "circle",
            linkIcon: "link",
        };
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
            startupData: (state: RootState) => state.application.startupData,
        }),
        ...mapGetters(["userDateFormat"]),
        host() {
            if (this.startupData && this.startupData.currentIp) return this.startupData.currentIp;
            return location.host;
        },
        protocolUrl() {
            if (this.localSession && this.localSession.port) {
                let user = "root";
                if (this.osType == OsTypeEnum.Windows) user = "retail";
                switch (this.localProtocol) {
                    case TunnelProtocolEnum.SSH:
                        return `ssh://${user}@${this.host}:${this.localSession.port}`;
                    case TunnelProtocolEnum.UltraVNC:
                        return `vnc://${this.host}:${this.localSession.port}`;
                    case TunnelProtocolEnum.HTTP:
                        return `http://${this.host}:${this.localSession.port}`;
                    case TunnelProtocolEnum.HTTPS:
                        return `https://${this.host}:${this.localSession.port}`;
                    case TunnelProtocolEnum.CaosDB:
                        return `http://${this.host}:${this.localSession.port}/phpmyadmin`;
                }
            }
            return "";
        },
        chartAgentTunnelServiceConnectedTime() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "bar",
                        stacked: true,
                        animations: {
                            enabled: false,
                        },
                        zoom: {
                            enabled: false,
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                        tickPlacement: "on",
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => {
                                if (value != null) {
                                    return this.formatSeconds(value, true);
                                }
                                return null;
                            },
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => this.formatSeconds(value),
                        },
                    },
                },
                series: this.seriesConnectedTime,
            };
        },
    },
    watch: {
        secureConnection(newValue) {
            if (newValue) this.localProtocol = TunnelProtocolEnum.HTTPS;
            else this.localProtocol = TunnelProtocolEnum.HTTP;
        },
        installationName: {
            handler() {
                this.showAlert = false;
                this.localSession = this.session;
                if (this.session && this.session.servicePort == TunnelProtocolToPort(TunnelProtocolEnum.HTTPS)) this.localProtocol = TunnelProtocolEnum.HTTPS;
                else this.localProtocol = this.protocol;
                this.startSessionLoading = false;
                this.stopSessionLoading = false;
                this.getAgentTunnelServiceConnectedTime();
            },
            immediate: true,
        },
        session() {
            this.localSession = this.session;
            if (this.session && this.session.servicePort == TunnelProtocolToPort(TunnelProtocolEnum.HTTPS)) this.localProtocol = TunnelProtocolEnum.HTTPS;
            else this.localProtocol = this.protocol;
        },
    },
    methods: {
        formatSeconds,
        TunnelProtocolEnumToString,
        TunnelProtocolToPort,
        TunnelProtocolEnumToProtocolName,
        async copy(type: string) {
            switch (type) {
                case "endpoint":
                    await navigator.clipboard.writeText(`${this.host}:${this.localSession.port}`);
                    this.copyIcon = "check";
                    setTimeout(() => {
                        this.copyIcon = "copy";
                    }, 1000);
                    break;
                case "host":
                    await navigator.clipboard.writeText(this.host);
                    this.cursorIcon = "check";
                    setTimeout(() => {
                        this.cursorIcon = "i-cursor";
                    }, 1000);
                    break;
                case "port":
                    await navigator.clipboard.writeText(this.localSession.port);
                    this.circleIcon = "check";
                    setTimeout(() => {
                        this.circleIcon = "circle";
                    }, 1000);
                    break;
                case "url":
                    await navigator.clipboard.writeText(this.protocolUrl);
                    this.linkIcon = "check";
                    setTimeout(() => {
                        this.linkIcon = "link";
                    }, 1000);
                    break;
            }
        },
        openUrl() {
            window.open(this.protocolUrl, "_blank");
        },
        async startSession() {
            this.showAlert = false;
            this.startSessionLoading = true;
            try {
                let response: StartAgentTunnelSessionResData = await new StartAgentTunnelSessionCommand(
                    this.installationName,
                    null,
                    TunnelProtocolToPort(this.localProtocol),
                    this.secureConnection
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    this.localSession = response.newSessions[0];
                    this.$emit("data-reload");
                } else {
                    throw response.message;
                }
            } catch (error) {
                this.showAlert = true;
                switch (error) {
                    case CReqExecutionResultEnum.AgentOffline:
                        this.errorMessage = this.$t("device_status.agentOfflineForInstallation", { task: "connect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.AgentNotInstalled:
                        this.errorMessage = this.$t("device_status.agentNotInstalled", { task: "connect" });
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.DeviceLocked:
                        this.errorMessage = this.$t("device_status.agentLocked", { task: "connect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.errorMessage = this.$t("device_status.operationNotAvailable", { task: "connection" });
                        this.alertType = "info";
                        break;
                    case CReqExecutionResultEnum.ServerError:
                        this.errorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.errorMessage = this.$t("remoteLink.invalidVersion");
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending Connect request ", error);
                        this.errorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                }
            }
            this.startSessionLoading = false;
        },
        async stopSession() {
            this.stopSessionLoading = true;
            this.showAlert = false;
            try {
                let response: ApiGenericResponse = await new StopAgentTunnelSessionCommand(this.installationName, TunnelProtocolToPort(this.localProtocol)).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    this.localSession = null;
                    this.localProtocol = this.protocol;
                    this.secureConnection = false;
                    this.$emit("data-reload");
                    await this.getAgentTunnelServiceConnectedTime();
                } else {
                    throw response.message;
                }
            } catch (error) {
                this.showAlert = true;
                switch (error) {
                    case CReqExecutionResultEnum.AgentOffline:
                        this.rebootErrorMessage = this.$t("device_status.agentOfflineForInstallation", { task: "disconnect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.AgentNotInstalled:
                        this.rebootErrorMessage = this.$t("device_status.agentNotInstalled", { task: "disconnect" });
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.DeviceLocked:
                        this.rebootErrorMessage = this.$t("device_status.agentLocked", { task: "disconnect" });
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.rebootErrorMessage = this.$t("device_status.operationNotAvailable", { task: "disconnection" });
                        this.alertType = "info";
                        break;
                    case CReqExecutionResultEnum.ServerError:
                        this.rebootErrorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.rebootErrorMessage = this.$t("remoteLink.invalidVersion");
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending Connect request ", error);
                        this.errorMessage = this.$t("device_status.serverError");
                        this.alertType = "error";
                        break;
                }
            }
            this.stopSessionLoading = false;
        },

        async getAgentTunnelServiceConnectedTime() {
            this.loadingChart = true;
            try {
                let response: GetAgentTunnelServiceConnectedTimeResData = await new GetAgentTunnelServiceConnectedTimeCommand(this.installationName, this.localProtocol).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString.toLowerCase() == "success") {
                    let values = [];
                    response.last7DaysSessionConnectedTime.forEach((value, date) => {
                        this.dateListString.push(moment(date).format(this.userDateFormat));
                        values.push(value);
                    });
                    if (values.reduce((partialSum, a) => partialSum + a, 0) > 0) this.seriesConnectedTime = [{ name: this.$t("remoteLink.connectedTime"), data: values }];
                    else this.seriesConnectedTime = [];
                } else {
                    throw response.message;
                }
            } catch (error) {
                console.log("Something went wrong sending GetAgentTunnelServiceConnectedTime request ", error);
            }
            this.loadingChart = false;
        },
    },
});
